module.exports = __webpack_public_path__ + "img/pragmatic-white.ae55ccc2.svg";